import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import { ensureValidAccessToken } from "../../Utils/tokenManager";

export const useDeleteSite = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (siteId: number) => {
      if (!siteId || isNaN(siteId)) throw new Error("Invalid site ID provided");

      const hasValidToken = await ensureValidAccessToken();
      if (!hasValidToken) throw new Error("Authentication failed. Please log in again.");

      const resp = await fetchClient<void>(`/iam/sites/${siteId}/`, { method: "DELETE" });

      if (resp.error) {
        const errorDetail = resp.error.detail || resp.error.message || "Unknown error";
        if (resp.status === 401) throw new Error("Authentication failed. Please log in again.");
        if (resp.status === 403)
          throw new Error("You don't have permission to delete this site.");
        throw new Error(`API Error: ${errorDetail}`);
      }

      return resp;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["sites"] });
      qc.invalidateQueries({ queryKey: ["site-groups"] });
    },
  });
};

export default useDeleteSite;
